import { observer } from "mobx-react-lite";
import { useForm } from "react-final-form";

import {
  CheckboxVisibility,
  Heading,
  SelectionMode,
  Stack,
  useTheme
} from "@bps/fluent-ui";
import { EpisodeOfCare } from "@stores/clinical/models/EpisodeOfCare.ts";
import { DetailsListField } from "@ui-components/form/DetailsListField.tsx";
import { FieldSpy } from "@ui-components/form/FieldSpy.tsx";

import { ActiveConditionListItem } from "../../../appointment-dialog/components/appointment-form/active-condition-list/ActiveConditionListItem.tsx";
import { ReviewConditionModalValues } from "./ReviewConditionModal.types.ts";

interface ReviewConditionModalFieldProps {
  episodeOfCare: EpisodeOfCare;
  heading: string;
  name: keyof ReviewConditionModalValues;
  readOnly?: boolean;
}

export const ReviewConditionModalField = observer(
  (props: ReviewConditionModalFieldProps) => {
    const { episodeOfCare, heading, name, readOnly } = props;

    const theme = useTheme();
    const form = useForm();

    const conditionListItem = {
      episodeOfCare,
      key: episodeOfCare.id
    };

    return (
      <Stack>
        <Heading labelPaddings>{heading}</Heading>
        {readOnly && (
          <Stack
            styles={{
              root: {
                border: `1px solid ${theme.palette.neutralLight}`,
                padding: "12px 16px"
              }
            }}
          >
            <ActiveConditionListItem conditionListItem={conditionListItem} />
          </Stack>
        )}
        {!readOnly && (
          <Stack
            styles={{
              root: {
                border: `1px solid ${theme.palette.neutralLight}`,
                borderBottom: 0
              }
            }}
          >
            <DetailsListField
              setKey={name}
              isHeaderVisible={false}
              selectionMode={SelectionMode.single}
              name={name}
              checkboxVisibility={CheckboxVisibility.always}
              items={[conditionListItem]}
              columns={[
                {
                  name: "condition",
                  key: "condition",
                  minWidth: 1,
                  flexGrow: 1,
                  onRender: () => (
                    <ActiveConditionListItem
                      conditionListItem={conditionListItem}
                    />
                  )
                }
              ]}
              fullRowSelection
            />
          </Stack>
        )}
        <FieldSpy
          name={name}
          onChange={value => {
            if (value) {
              if (name === "apptCondition") {
                form.change("consultCondition", undefined);
              } else {
                form.change("apptCondition", undefined);
              }
            }
          }}
        />
      </Stack>
    );
  }
);
